import { groupBy } from "@edgetier/utilities";
import { formatUnderscoreName } from "utilities/format-underscore-name";
import { ITag } from "@edgetier/watchtower-types";

/**
 * Make the tag group names nicer.
 * @param tags Tags before formatting.
 * @returns    Tags with nicer tag group names.
 */
export const formatTags = (tags: ITag[]) => {
    return tags.map((tag) => ({ ...tag, tagGroup: formatUnderscoreName(tag.tagGroup) }));
};

/**
 * Group tags into tag groups.
 * @param tags All tags.
 * @returns    A dictionary from tag group ID to tags.
 */
export const groupTags = (tags: ITag[]) => {
    const formattedTags = formatTags(tags);
    return Object.entries(groupBy(formattedTags, ({ tagGroup }) => tagGroup)).sort(([tagGroupOne], [tagGroupTwo]) =>
        tagGroupOne.localeCompare(tagGroupTwo)
    );
};
